import React from 'react';
import Places from '../components/Place/Places';
const Place = () => {
    return ( <Places/> );
}
 
export default Place;